import type { AppState, Payload } from 'store/state';

export function userAction(state: AppState, payload: Payload): AppState {
	return {
		...state,
		user: {
			...state.user,
			...payload.user
		}
	};
}
